import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

const Stars = () => (
  <div className="flex gap-0.5" role="img" aria-label="Classificação: 5 de 5 estrelas">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={15} className="fill-amber-400 text-amber-400" />
    ))}
  </div>
);

export default function Testimonials() {
  return (
    <section id="avaliacoes" data-testid="testimonials-section" className="scroll-mt-24 bg-cream/70 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <SectionHead
          overline="Avaliações"
          title="O que dizem os nossos clientes"
          text="Avaliações reais deixadas por clientes EcoJard na plataforma Zaask."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.author} delay={0.07 * i}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col rounded-3xl border border-stone2 bg-white p-7 transition-shadow duration-300 hover:shadow-[0_24px_50px_-24px_rgba(18,37,26,0.25)]"
              >
                <Stars />
                <blockquote className="mt-5 flex-1 font-serif text-lg leading-relaxed text-ink">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-6 border-t border-sand pt-4">
                  <p className="text-sm font-semibold text-ink">{t.author}</p>
                  <p className="mt-0.5 text-xs text-moss">{t.meta}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
